var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartPut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58896 18.5636C6.11965 22.3586 10.4035 26.5476 17.0468 30.9386C23.6901 26.5476 27.9739 22.3586 30.5046 18.5636H25.2968C25.0908 18.5636 24.8896 18.5019 24.719 18.3864C24.5485 18.271 24.4164 18.1072 24.3398 17.916L21.3347 10.4044L18.0388 21.9399C17.9799 22.1468 17.8578 22.3301 17.6895 22.4641C17.5212 22.5981 17.3153 22.6761 17.1004 22.6873C16.8856 22.6984 16.6727 22.6421 16.4915 22.5262C16.3102 22.4103 16.1698 22.2407 16.0898 22.041L12.6928 13.5476L9.65478 18.1057C9.56045 18.2467 9.43281 18.3623 9.28314 18.4422C9.13348 18.522 8.96642 18.5638 8.79677 18.5636H3.58896ZM2.35971 16.5011C-4.45685 3.46611 9.6424 -4.12389 16.6838 2.35855C16.8075 2.47199 16.9292 2.58955 17.0468 2.71124C17.1631 2.58966 17.2842 2.4727 17.4098 2.36061C24.4511 -4.12389 38.5504 3.46611 31.7318 16.5011H25.9918L22.1267 6.83624C22.0467 6.63656 21.9063 6.4669 21.725 6.35101C21.5438 6.23512 21.3309 6.1788 21.116 6.18994C20.9012 6.20108 20.6953 6.27912 20.527 6.41313C20.3587 6.54714 20.2366 6.73042 20.1776 6.9373L16.8838 18.4729L13.8788 10.9612C13.8088 10.787 13.6926 10.6351 13.5426 10.5221C13.3927 10.4091 13.2147 10.3391 13.0279 10.3198C12.8411 10.3005 12.6526 10.3325 12.4827 10.4125C12.3128 10.4925 12.1679 10.6173 12.0638 10.7736L8.24403 16.5011H2.36178H2.35971Z",
    fill: "#FFC530"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartPut);
export default __webpack_public_path__ + "static/media/heart_put.1d1d2b6df888b90a92d9db71a64c9f80.svg";
export { ForwardRef as ReactComponent };